import { render } from "./dialog-attachment.vue?vue&type=template&id=ef2724cc&scoped=true"
import script from "./dialog-attachment.vue?vue&type=script&lang=js"
export * from "./dialog-attachment.vue?vue&type=script&lang=js"

import "./dialog-attachment.vue?vue&type=style&index=0&id=ef2724cc&lang=scss&scoped=true"

import exportComponent from "D:\\project\\php\\quickadmin\\vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef2724cc"]])

export default __exports__